import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CalendarDays, ArrowRight } from "lucide-react";
import { publicApi } from "../../admin/adminApi";
import "./Blog.css";
export default function BlogList() {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  useEffect(() => {
    document.title = "Blog — What Next";
    let cancelled = false;
    async function load() {
      try {
        const data = await publicApi.listBlogs();
        if (!cancelled) setBlogs(data);
      } catch (err) {
        if (!cancelled) setError(err.message);
      } finally {
        if (!cancelled) setLoading(false);
      }
    }
    load();
    return () => {
      cancelled = true;
    };
  }, []);
  return (
    <main className="blog-page">
      <div className="container blog-page__inner">
        <header className="blog-page__header">
          <h1>Our Blog</h1>
          <p>Guides, tips and updates from the What Next team.</p>
        </header>
        {loading ? (
          <p>Loading posts…</p>
        ) : error ? (
          <p className="blog-page__error">Could not load blog posts right now. Please try again later.</p>
        ) : blogs.length === 0 ? (
          <p>No posts published yet — check back soon.</p>
        ) : (
          <div className="blog-grid">
            {blogs.map((post) => {
              const thumb = post.coverImage || post.images?.[0];
              return (
              <Link to={`/blog/${post.slug}`} key={post._id} className="blog-card">
                {thumb && (
                  <div className="blog-card__image" style={{ backgroundImage: `url(${thumb})` }} />
                )}
                <div className="blog-card__body">
                  {post.category && <span className="blog-card__category">{post.category}</span>}
                  <h2>{post.title}</h2>
                  {post.excerpt && <p>{post.excerpt}</p>}
                  <div className="blog-card__meta">
                    <span>
                      <CalendarDays size={14} />{" "}
                      {post.publishedAt ? new Date(post.publishedAt).toLocaleDateString() : ""}
                    </span>
                    <span className="blog-card__readmore">
                      Read more <ArrowRight size={14} />
                    </span>
                  </div>
                </div>
              </Link>
              );
            })}
          </div>
        )}
      </div>
    </main>
  );
}